import React, { Component, useEffect, useRef, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { getAlert } from "../../../services/appAlerts";
import useControls from "../../../app/hooks/useControls";
import useForm from "../../../app/hooks/useForm";
import { getCurrentUser } from "../../../app/store/auth";
import { useDispatch, useSelector } from "react-redux";
import {
  SendAddedEmailMessage,
  addNewEmailMessage, emailMessageAdded,
  getEmailAddedStatus, getEmailUpdatedStatus, getMailDocUploadSasRes, getSentEmailStatus, updateEmailMessage
} from "../../../app/store/users";
import { uploadFileToBlob } from "../../../services/blobUploadService";
import UploadDocument from "../../../comman/UploadDocument";

const formatFileSize = (bytes) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

const SendEmail = (props) => {
  const { 
    showHide, 
    handleModalShowHide, 
    selectedEmail,
    selectedObj, 
    viewType, 
    selectedMailObj, 
    handleUpdateModalShowHide, 
    msgType, 
    isInline 
  } = props;

  const [saveBtnType, setSaveBtnType] = useState("");
  const [saveBtnProcess, setSaveBtnProcess] = useState(false);
  const [draftBtnProcess, setDraftBtnProcess] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [recipients, setRecipients] = useState([]);

  const emailAddedStatusSelector = useSelector(getEmailAddedStatus);
  const sentEmailStatusSelector = useSelector(getSentEmailStatus);
  const emailUpdatedStatusSelector = useSelector(getEmailUpdatedStatus);
  const mailDocUploadSasResSelector = useSelector(getMailDocUploadSasRes);

  const currentUser = getCurrentUser();
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const uploadSentRef = useRef(null);

  useEffect(() => {
    const dt = {};
    if (selectedObj) {
      dt["emailTo"] = selectedObj.performeremail;
      dt["performerId"] = selectedObj.performerid;
      dt["ciid"] = selectedObj.ciid;
      dt["wiid"] = selectedObj.wiid;
      dt["iiid"] = selectedObj.iiid;
      dt["emails"] = [{ key: selectedObj.performerid, value: selectedObj.performeremail }];
      setRecipients([{ key: selectedObj.performerid, value: selectedObj.performeremail }]);
    }

    if (selectedEmail?.length > 0) {
      dt["emailTo"] = selectedEmail.map((x) => x.value).join(", ");
      dt["emails"] = selectedEmail;
      setRecipients(selectedEmail);
    }

    dt["subject"] = "";
    dt["mailBody"] = "";
    dt["addedBy"] = currentUser.id;

    setStateData(dt);
  }, [selectedObj, selectedEmail]);

  useEffect(() => {
    const dt = {};
    if (selectedMailObj) {
      dt["emailTo"] = selectedMailObj.emailTo;
      dt["id"] = selectedMailObj.id;
      dt["subject"] = selectedMailObj.subject;
      dt["mailBody"] = selectedMailObj.mailBody;
      setStateData(dt);
      
      if (selectedMailObj.emailTo) {
        const parsed = selectedMailObj.emailTo.split(",").map(e => e.trim()).filter(e => e).map(e => ({ key: e, value: e }));
        setRecipients(parsed);
      }
    }
  }, [selectedMailObj]);

  const schema = {};

  useEffect(() => {
    if (emailAddedStatusSelector) {
      setSaveBtnProcess(false);
      setDraftBtnProcess(false);
      if (saveBtnType === "draft") {
        getAlert("Saved Successfully", "", "success");
      }
      handleModalShowHide("save");
      dispatch(emailMessageAdded(false));
      setStateData({});
      setDocuments([]);
    }
  }, [emailAddedStatusSelector]);

  useEffect(() => {
    if (emailUpdatedStatusSelector) {
      getAlert("Updated Successfully", "", "success");
      setSaveBtnProcess(false);
      setDraftBtnProcess(false);
      if (handleUpdateModalShowHide) handleUpdateModalShowHide();
    }
  }, [emailUpdatedStatusSelector]);

  const doSubmit = (btnType) => {
    setSaveBtnType(btnType);
    const payload = {
      emailTo: recipients.map(x => x.value).join(", "),
      emails: JSON.stringify(recipients),
      subject: stateData.subject || "",
      emailFrom: stateData.emailFrom || "",
      mailBody: stateData.mailBody || "",
      addedBy: Number(stateData.addedBy) || 0,
      ciid: Number(stateData.ciid) || 0,
      wiid: Number(stateData.wiid) || 0,
      iiid: Number(stateData.iiid) || 0,
      sendStatus: btnType === "send",
      files: documents?.map(x => ({
        name: x.name,
        type: x.type,
        size: x.size
      })) || []
    };

    if (btnType === "send") {
      setSaveBtnProcess(true);
    } else if (btnType === "draft") {
      setDraftBtnProcess(true);
    }

    if (btnType === "Update") {
      dispatch(updateEmailMessage(payload));
    } else {
      dispatch(addNewEmailMessage(payload));
    }
  };

  useEffect(() => {
    const uploadAllDocuments = async () => {
      if (mailDocUploadSasResSelector && uploadSentRef.current === mailDocUploadSasResSelector) {
        return;
      }
      if (mailDocUploadSasResSelector?.historyIds?.length > 0) {
        uploadSentRef.current = mailDocUploadSasResSelector;
        try {
          if (documents?.length > 0 && mailDocUploadSasResSelector?.sasUrls?.length > 0) {
            await Promise.all(
              mailDocUploadSasResSelector.sasUrls.map((sas) => {
                const matchedDoc = documents.find(
                  (doc) => doc.name.toLowerCase() === sas.blobName?.toLowerCase() ||
                           doc.name.toLowerCase() === sas.fileName?.toLowerCase() || 
                           doc.name.toLowerCase() === sas.filename?.toLowerCase() ||
                           doc.name.toLowerCase() === sas.name?.toLowerCase()
                ) || documents[0];
                return uploadFileToBlob(
                  matchedDoc.file,
                  sas.uploadUrl,
                  () => {}
                );
              })
            );
          }
          if (saveBtnType === "send") {
            getAlert("Sent Successfully", "", "success");
            const sendSequentially = async () => {
              for (const historyId of mailDocUploadSasResSelector.historyIds) {
                try {
                  await dispatch(SendAddedEmailMessage(historyId));
                } catch (err) {
                  console.error("Failed to send bulk email for historyId:", historyId, err);
                }
              }
            };
            sendSequentially();
          }
        } catch (error) {
          console.error("Upload failed:", error);
        }
      }
    };
    uploadAllDocuments();
  }, [mailDocUploadSasResSelector]);

  const onFileChange = async (event) => {
    const docs = [...documents];
    for (const file of event.target.files) {
      var doc = {
        name: file.name,
        type: file.type,
        size: file.size,
        file: file,
      };
      docs.push(doc);
    }
    setDocuments(docs);
    setStateData((prevState) => ({
      ...prevState,
      documents: docs
    }));
  };

  const handleFileRemove = (item) => {
    const updatedDocuments = documents.filter((doc) => doc !== item);
    setDocuments(updatedDocuments);
  };

  const modalClose = () => {
    setStateData({});
    setDocuments([]);
    handleModalShowHide("");
  };

  const { handleChange, stateData, setStateData, stateErrors, handleSubmit } = useForm(schema, doSubmit);
  const { renderInput, renderTextArea } = useControls(stateData, stateErrors, handleChange, schema);

  const handleRemoveRecipient = (target) => {
    setRecipients(prev => prev.filter(r => r.key !== target.key));
  };

  const renderFormContent = () => {
    return (
      <div className="row">
        <div className="col-md-12 form-group">
          <label className="form-control-label">To Recipients {recipients.length > 0 && <span className="awp-req ml-2">({recipients.length})</span>}
          </label>
          <div className="wf-badges-container">
            {recipients.length > 0 ? (
              recipients.map((item, idx) => (
                <span key={idx} className="wf-recipient-badge">
                  <i className="fa fa-envelope" aria-hidden="true" /> {item.value}
                  <button
                    type="button"
                    className="wf-badge-remove-btn"
                    onClick={() => handleRemoveRecipient(item)}
                  >
                    <i className="fa fa-times" aria-hidden="true" />
                  </button>
                </span>
              ))
            ) : (
              <span className="text-muted small" style={{ padding: "4px 0" }}>No recipients available</span>
            )}
          </div>
        </div>

        <div className="col-md-12 form-group">
          <label className="form-control-label">Subject
          </label>
          <div className="wf-input-wrap">
            <input
              type="text"
              name="subject"
              className="form-control"
              placeholder="Enter subject line..."
              value={stateData.subject || ""}
              onChange={handleChange}
              autoComplete="off"
            />
          </div>
        </div>

        <div className="col-md-12 form-group">
          <label className="form-control-label">Message Body
          </label>
          <div className="wf-input-wrap">
            <textarea
              name="mailBody"
              className="form-control"
              rows="6"
              placeholder="Type your message here..."
              value={stateData.mailBody || ""}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="col-md-12 form-group mb-0">
          <UploadDocument
            documents={documents}
            onFileChange={onFileChange}
            handleFileRemove={handleFileRemove}
            btnLable="Add Attachment"
          />
        </div>
      </div>
    );
  };

  const styles = `
    /* Ensure the modal and backdrop are on top of other elements */
    .modal-backdrop {
      z-index: 1080 !important;
    }
    .modal {
      z-index: 1090 !important;
      overflow-y: hidden !important;
    }

    /* Glassmorphic backdrop filter and blur */
    .modal-backdrop.show {
      backdrop-filter: blur(8px) !important;
      -webkit-backdrop-filter: blur(8px) !important;
      background-color: rgba(15, 23, 42, 0.45) !important;
      opacity: 1 !important;
    }

    .modal.fade .wf-email-modal.modal-dialog {
      transform: scale(0.96) !important;
      transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
    }
    .modal.show .wf-email-modal.modal-dialog {
      transform: scale(1) !important;
    }

    .wf-email-modal {
      max-width: 680px !important;
      width: 95% !important;
      font-family: "Open Sans", sans-serif !important;
    }

    .wf-email-modal .modal-content {
      border-radius: 0 !important;
      border: 1px solid #cbd5e1 !important;
      box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25) !important;
      overflow: hidden !important;
      background: #ffffff !important;
    }

    .wf-email-modal .modal-header {
      position: relative !important;
      display: block !important;
      padding: 14px 24px !important;
      background: #ffffff !important;
      border-bottom: 1px solid #edf2f7 !important;
      overflow: hidden !important;
    }

    .wf-email-modal .modal-header::before {
      display: none !important;
    }

    .wf-email-modal .rt-header-shell {
      display: flex !important;
      flex-direction: column !important;
      width: 100% !important;
    }

    .wf-email-modal .rt-header-top {
      display: flex !important;
      justify-content: space-between !important;
      align-items: center !important;
      gap: 16px !important;
      width: 100% !important;
    }

    .wf-email-modal .rt-header-main {
      display: flex !important;
      align-items: center !important;
      gap: 14px !important;
      min-width: 0 !important;
      flex: 1 1 auto !important;
    }

    .wf-email-modal .rt-header-copy {
      display: flex !important;
      flex-direction: column !important;
      gap: 2px !important;
      min-width: 0 !important;
    }

    .wf-email-modal .rt-modal-title {
      display: inline-flex !important;
      align-items: center !important;
      margin: 0 !important;
      color: #0f172a !important;
      font-size: 17px !important;
      font-weight: 600 !important;
      line-height: 1.25 !important;
    }

    .wf-email-modal .rt-header-icon {
      width: 38px !important;
      height: 38px !important;
      min-height: 38px !important;
      border-radius: 0 !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      color: #171717 !important;
      background: #f5f5f5 !important;
      border: 1px solid #d4d4d4 !important;
      box-shadow: 0 2px 5px rgba(15,23,42,0.06) !important;
      font-size: 16px !important;
      flex-shrink: 0 !important;
    }

    .wf-email-modal .rt-modal-title-text {
      display: inline-flex !important;
      align-items: center !important;
      gap: 8px !important;
      flex-wrap: wrap !important;
    }

    .wf-email-modal .rt-modal-title-badge {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      padding: 3px 8px !important;
      border-radius: 0 !important;
      font-size: 10px !important;
      font-weight: 700 !important;
      text-transform: uppercase !important;
      letter-spacing: 0.04em !important;
      background: #171717 !important;
      color: #ffffff !important;
      border: 1px solid #171717 !important;
    }

    .wf-email-modal .rt-modal-desc {
      display: inline-flex !important;
      align-items: center !important;
      gap: 6px !important;
      color: #64748b !important;
      font-weight: 400 !important;
      line-height: 1.4 !important;
      font-size: 12px !important;
    }

    .wf-email-modal .rt-action-btn {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      width: 32px !important;
      height: 32px !important;
      padding: 0 !important;
      font-size: 14px !important;
      color: #64748b !important;
      background: #ffffff !important;
      border: 1px solid #cbd5e1 !important;
      border-radius: 0 !important;
      cursor: pointer !important;
      transition: all 0.2s ease !important;
      box-shadow: 0 2px 5px rgba(15, 23, 42, 0.06) !important;
      outline: none !important;
    }
    .wf-email-modal .rt-action-btn:hover {
      color: #ef4444 !important;
      border-color: #fca5a5 !important;
      background: #fef2f2 !important;
      transform: translateY(-1px) !important;
    }

    .wf-email-modal .modal-body {
      padding: 20px 24px !important;
      background: #ffffff !important;
      max-height: calc(90vh - 140px) !important;
      overflow-y: auto !important;
    }

    .wf-email-modal .modal-footer {
      background: #f8fafc !important;
      border-top: 1px solid #edf2f7 !important;
      padding: 14px 24px !important;
      display: flex !important;
      justify-content: flex-end !important;
      gap: 10px !important;
    }

    .awp-card {
      border: none;
      border-radius: 0;
      background: #ffffff;
      box-shadow: none;
      margin-top: 10px;
      animation: awpFadeIn 0.3s ease both;
      overflow: visible;
    }
    
    @keyframes awpFadeIn {
      from { opacity: 0; transform: translateY(6px); }
      to   { opacity: 1; transform: translateY(0); }
    }

    .awp-form-header {
      display: flex; align-items: center; gap: 14px;
      padding: 16px 22px;
      background: #ffffff !important;
      border: 1px solid #cbd5e1 !important;
      border-radius: 0 !important;
      position: relative; overflow: hidden;
      margin-bottom: 16px;
    }
    .awp-form-header-icon {
      width: 42px; height: 42px; border-radius: 0 !important;
      background: #ffffff !important; border: 1px solid #cbd5e1 !important;
      display: flex; align-items: center; justify-content: center;
      font-size: 17px; color: #171717; flex-shrink: 0;
    }
    .awp-form-header-title {
      color: #171717; font-size: 14.5px; font-weight: 700; margin: 0; line-height: 1.2;
    }
    .awp-form-header-sub {
      color: #737373; font-size: 12px; margin-top: 3px; font-weight: 400; margin-bottom: 0;
    }

    .awp-form-body {
      padding: 0;
      background: #ffffff;
    }

    .form-control-label {
      font-size: 11.5px !important; font-weight: 700 !important; color: #334155 !important;
      text-transform: uppercase !important; letter-spacing: 0.04em !important;
      margin-bottom: 6px !important; display: flex !important;
      align-items: center !important; gap: 5px !important;
    }
    .form-group { margin-bottom: 16px; }

    .wf-badges-container {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      padding: 8px 12px;
      background: #ffffff;
      border: 1px solid #cbd5e1;
      border-radius: 0;
      min-height: 42px;
      box-shadow: inset 0 1px 2px rgba(0,0,0,0.02);
    }

    .wf-recipient-badge {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      background: #ffffff;
      border: 1px solid #cbd5e1;
      padding: 4px 10px;
      border-radius: 0;
      font-size: 12.5px;
      font-weight: 500;
      color: #1e293b;
    }

    .wf-recipient-badge i {
      color: #64748b;
      font-size: 11px;
    }
    .wf-badge-remove-btn {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      width: 16px !important;
      height: 16px !important;
      border-radius: 0 !important;
      background: rgba(239, 68, 68, 0.1) !important;
      color: #ef4444 !important;
      border: none !important;
      padding: 0 !important;
      margin-left: 6px !important;
      cursor: pointer !important;
      transition: all 0.2s ease !important;
      font-size: 9px !important;
      outline: none !important;
      box-shadow: none !important;
    }
    .wf-badge-remove-btn i {
      color: #ef4444 !important;
      font-size: 9px !important;
    }
    .wf-badge-remove-btn:hover {
      background: #ef4444 !important;
      color: #ffffff !important;
    }
    .wf-badge-remove-btn:hover i {
      color: #ffffff !important;
    }

    .wf-input-wrap { position: relative; }

    .form-control {
      border-radius: 0 !important;
      border: 1px solid #cbd5e1 !important;
      padding: 8px 12px !important;
      font-size: 13.5px !important;
      color: #0f172a !important;
      background: #ffffff !important;
      transition: all 0.2s ease !important;
      box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
      width: 100% !important;
      height: auto !important;
    }
    .form-control:hover {
      border-color: #94a3b8 !important;
    }
    .form-control:focus {
      border-color: #2563eb !important;
      box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12) !important;
      outline: none !important;
    }

    .awp-form-footer {
      display: flex; align-items: center; justify-content: flex-end;
      gap: 10px; flex-wrap: wrap; padding: 16px 0 0;
      border-top: none;
      background: #ffffff;
    }

    .awp-req {
      color: #ef4444; font-weight: 700; font-size: 12px;
    }
    
    .btn-action-search {
      display: inline-flex !important; align-items: center !important; justify-content: center !important; gap: 7px !important;
      background: #ffffff !important; border: 1px solid #cbd5e1 !important;
      padding: 7px 16px !important; border-radius: 0 !important;
      font-size: 13.5px !important; font-weight: 500 !important; color: #1e293b !important;
      cursor: pointer !important; transition: all 0.2s ease !important;
      box-shadow: 0 2px 5px rgba(15, 23, 42, 0.06) !important;
    }
    .btn-action-search:hover {
      background: #f8fafc !important; border-color: #94a3b8 !important; color: #0f172a !important;
      transform: translateY(-1px) !important;
      box-shadow: 0 3px 8px rgba(15, 23, 42, 0.1) !important;
    }
    .btn-action-search.btn-primary-search,
    .btn-primary-search {
      background: #2563eb !important; color: #ffffff !important; border-color: #2563eb !important;
      font-weight: 500 !important;
      box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2) !important;
    }
    .btn-action-search.btn-primary-search:hover,
    .btn-primary-search:hover {
      background: #1d4ed8 !important; border-color: #1d4ed8 !important;
      box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3) !important;
    }
    .btn-action-search:disabled,
    .btn-action-search.btn-primary-search:disabled {
      background: #cbd5e1 !important; color: #94a3b8 !important; border-color: #cbd5e1 !important;
      cursor: not-allowed !important; opacity: 0.85 !important; transform: none !important;
      box-shadow: none !important;
    }
`;

  if (isInline) {
    return (
      <div className="awp-card">
        <style>{styles}</style>
        <div className="awp-form-header">
          <div className="awp-form-header-icon">
            <i className="fa fa-envelope" />
          </div>
          <div className="awp-form-header-text">
            <p className="awp-form-header-title">
              {selectedEmail?.length > 0 ? "Compose Bulk Message" : "Compose Message"}
            </p>
            <p className="awp-form-header-sub">
              {selectedEmail?.length > 0 ? `Sending to ${selectedEmail.length} selected recipients` : "Type your message and manage attachments below"}
            </p>
          </div>
          <button
            type="button"
            className="btn-action-search"
            onClick={modalClose}
            style={{ marginLeft: "auto" }}
          >
            <i className="fa fa-arrow-left" aria-hidden="true" />
            Back
          </button>
        </div>
        <div className="awp-form-body">
          {renderFormContent()}
        </div>
        <div className="awp-form-footer">
          <button
            type="button"
            className="btn-action-search"
            onClick={modalClose}
          >
            <i className="fa fa-arrow-left" aria-hidden="true" />
            Back
          </button>
          {viewType === "edit" &&
            <button className="btn-action-search btn-primary-search" disabled={saveBtnProcess || recipients.length === 0} onClick={() => handleSubmit("Update")}>
              {saveBtnProcess ? <i className="fa fa-circle-o-notch fa-spin"></i> : <i className="fa fa-pencil" aria-hidden="true"></i>} Update Message
            </button>
          }
          {viewType === "add" && <>
            <button className="btn-action-search" disabled={draftBtnProcess || recipients.length === 0} onClick={() => handleSubmit("draft")}>
              {draftBtnProcess ? <i className="fa fa-circle-o-notch fa-spin"></i> : <i className="fa fa-check" aria-hidden="true"></i>} Save as Draft
            </button>
            <button className="btn-action-search btn-primary-search" disabled={saveBtnProcess || recipients.length === 0} onClick={() => handleSubmit("send")}>
              {saveBtnProcess ? <i className="fa fa-circle-o-notch fa-spin"></i> : <i className="fa fa-paper-plane" aria-hidden="true"></i>} Send Message
            </button> </>
          }
        </div>
      </div>
    );
  }

  return (
    <Modal
      show={showHide}
      dialogClassName="wf-email-modal"
      centered
      onHide={modalClose}
    >
      <style>{styles}</style>
      <Modal.Header>
        <div className="rt-header-shell">
          <div className="rt-header-top">
            <div className="rt-header-main">
              <i className="rt-header-icon fa fa-envelope" aria-hidden="true" />
              <div className="rt-header-copy">
                <h2 className="rt-modal-title">
                  <span className="rt-modal-title-text">
                    <span>
                      {viewType === "edit"
                        ? "Edit Draft Message"
                        : selectedEmail?.length > 1
                        ? "Send Bulk Email"
                        : "Send Message"}
                    </span>
                    <span className="rt-modal-title-badge">
                      {viewType === "edit"
                        ? "Draft"
                        : selectedEmail?.length > 1
                        ? "Bulk"
                        : "Compose"}
                    </span>
                  </span>
                </h2>
                <span className="rt-modal-desc">
                  {viewType === "edit"
                    ? "Modify saved draft message and attachments below."
                    : selectedEmail?.length > 0
                    ? `Recipient count: ${selectedEmail.length}`
                    : "Transmit correspondence to the selected recipient."}
                </span>
              </div>
            </div>
            <button
              type="button"
              className="rt-action-btn"
              onClick={modalClose}
              title="Close"
            >
              <i className="fa fa-times" aria-hidden="true" />
            </button>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body>
        {renderFormContent()}
      </Modal.Body>

      <Modal.Footer>
        <button
          type="button"
          className="btn-action-search"
          onClick={modalClose}
        >
          <i className="fa fa-times" aria-hidden="true" /> Close
        </button>
        {viewType === "edit" && (
          <button
            type="button"
            className="btn-action-search btn-primary-search"
            disabled={saveBtnProcess || recipients.length === 0}
            onClick={() => handleSubmit("Update")}
          >
            {saveBtnProcess ? (
              <i className="fa fa-circle-o-notch fa-spin" />
            ) : (
              <i className="fa fa-pencil" aria-hidden="true" />
            )}{" "}
            Update Message
          </button>
        )}
        {viewType === "add" && (
          <>
            <button
              type="button"
              className="btn-action-search"
              disabled={draftBtnProcess || recipients.length === 0}
              onClick={() => handleSubmit("draft")}
            >
              {draftBtnProcess ? (
                <i className="fa fa-circle-o-notch fa-spin" />
              ) : (
                <i className="fa fa-check" aria-hidden="true" />
              )}{" "}
              Save as Draft
            </button>
            <button
              type="button"
              className="btn-action-search btn-primary-search"
              disabled={saveBtnProcess || recipients.length === 0}
              onClick={() => handleSubmit("send")}
            >
              {saveBtnProcess ? (
                <i className="fa fa-circle-o-notch fa-spin" />
              ) : (
                <i className="fa fa-paper-plane" aria-hidden="true" />
              )}{" "}
              Send Message
            </button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default SendEmail;
